import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetErrorLogsMutation } from '../../../api/ErrorAPI';
import { IErrorMessage } from '../../../types/Types';
import Footer from '../../footer/Footer';
import LandingpageHeader from '../../header/LandingpageHeader';
import { formatToEuroDateTime } from '../../../util/DateUtils';

export default function ErrorMessages() {

  //const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  //const [daten, setDaten] = useState<IMwstSatz>({ uid: '', satz: 0, gueltigAb: new Date() });
  const [getListe] = useGetErrorLogsMutation();
  const [liste, setListe] = useState<IErrorMessage[]>([]);

  const lade = () => {

    getListe().unwrap()
      .then((data) => setListe(data));

  }

  useEffect(() => {
    lade();
  }, []);

  return (
    <>
      <div>

        <LandingpageHeader />

        <div style={{ padding: "20px" }}>

          <div className="container">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <button
                onClick={() => {
                  navigate({
                    pathname: "/",
                    search: ""
                  });
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              >
                <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>
            </div>

            <h3>ErrorMessages</h3>
            
            <p>
              Anzahl {liste.length}
            </p>

            <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
              <div>Erstellt am</div>
              <div>API</div>
              <div>Status</div>
              <div>Message</div>
              <div>Profil</div>
            </div>

            {liste.map((e, index) => <>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{formatToEuroDateTime(e.erstelltAm)}</div>
                <div>{e.api}</div>
                <div>{e.status}</div>
                <div>{e.message}</div>
                <div>{e.profileName}</div>
              </div>
            </>)}


        </div>
      </div>
    </div >
      <Footer />
    </>
  );
}
